import React from 'react'
import { Card, DataTable } from '@planningcenter/tapestry-react'

const defaultVariant = {
  header: {
    position: 'static',
  },
  bodyRow: ({ evenRow }) => ({
    backgroundColor: evenRow ? 'white' : 'surfaceSecondary',
    paddingVertical: 3,
    alignItems: 'start',
  }),
  bodyCell: { fontSize: 3 },
}

const Table = props => {
  return (
    <Card marginBottom={2}>
      <DataTable variant={defaultVariant} {...props} />
    </Card>
  )
}

export default Table
